import { ICoursesReducer } from '../Interfacese/ICoursesReducer';
import { metadataWithPagingInitState } from '../../CourseInstance/Reducers/CourseInstanceInitState';
import { CoursesListResponse } from '../Types/CoursesListResponse';

export const coursesListInitState: CoursesListResponse = {
  data: [],
  metadata: metadataWithPagingInitState,
};

export const productsListInitState = [];

export const coursesInitState: ICoursesReducer = {
  coursesList: coursesListInitState,
  productList: productsListInitState,
};
